import React, { memo, useEffect } from "react";
import { makeStyles } from "@mui/styles";
import { useDispatch } from "react-redux";
import useMulticotizadorSelector from "./useMulticotizadorSelector";
import { clearVehiculoAnio, setVehiculoAnio } from "../actions";
import VehiculoAnioSelector from "~business/vehiculoAnioSelector/VehiculoAnioSelector";
import MulticotizadorContent from "./MulticotizadorContent";
import PrimaryTitle from "~styled/primaryTitle/PrimaryTitle";

const useStyles = makeStyles((theme) => ({
  title: {
    paddingBottom: "16px",
  },
}));

const useReduxSelector = () =>
  useMulticotizadorSelector((state) => ({
    anioSelected: state.anioSelected,
  }));

const AnioStep = memo(() => {
  const classes = useStyles();
  const dispatch = useDispatch();
  const { anioSelected } = useReduxSelector();

  useEffect(() => {
    dispatch(clearVehiculoAnio());
  }, [dispatch]);

  const handleChange = (event: { target: { value: string } }) => {
    dispatch(
      setVehiculoAnio({
        label: event.target.value,
        value: event.target.value,
      })
    );
  };

  return (
    <>
      <MulticotizadorContent>
        <div className={classes.title}>
          <PrimaryTitle
            label="Ingresá el año del vehículo del asegurado"
            marginBottom={32}
          />
        </div>
        <VehiculoAnioSelector value={anioSelected} onChange={handleChange} />
      </MulticotizadorContent>
    </>
  );
});

export default AnioStep;
